import { QueryResult, useQuery } from "@apollo/client";
import {
  GetReportDetailsQuery,
  GetReportDetailsQueryVariables,
  ProgramArea,
} from "generated-graphql/graphql";
import React, { createContext } from "react";

import { GET_REPORT } from "./useReport";

export const ReportContext = createContext<
  QueryResult<GetReportDetailsQuery, GetReportDetailsQueryVariables> | undefined
>(undefined);

export function ReportProvider({
  reportId,
  children,
}: {
  reportId: string | undefined;
  children: React.ReactNode;
}) {
  const queryResult = useQuery(GET_REPORT, {
    variables: {
      reportId: reportId ?? "",
      programArea: ProgramArea.Epcra,
      version: undefined,
    },
    skip: !reportId,
    fetchPolicy: "network-only",
  });
  return <ReportContext.Provider value={queryResult}>{children}</ReportContext.Provider>;
}
